import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Permission, UserContext, UserContextProps } from './user-context';
import jwtDecode, { JwtPayload } from 'jwt-decode';

export const UserProvider: React.FC = ({ children }) => {
  const { user, getAccessTokenSilently } = useAuth0();
  const [permissions, setPermissions] = useState<Permission[]>([]);

  // ユーザーの設定とJWTデコードして権限を取得する
  useEffect(() => {
    let isMounted = true;

    const fetchPermissions = async () => {
      if (user != null) {
        try {
          // Properly await the token
          const value = await getAccessTokenSilently();
          const decoded = jwtDecode<JwtPayload & { permissions: Permission[] }>(value);

          // Only update state if component is still mounted
          if (isMounted) {
            setPermissions(decoded.permissions);
          }
        } catch (error) {
          console.error('Failed to get token or decode permissions:', error);
        }
      }
    };

    fetchPermissions();

    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, [user, getAccessTokenSilently]);

  const result: UserContextProps = {
    userInfo: {
      user: user,
      permissions,
      roles: user ? user['https://www.softbankgift.co.jp/roles'] : [],
    },
  };

  return <UserContext.Provider value={result}>{children}</UserContext.Provider>;
};
